import { Button } from 'carbon-components-react';
import * as React from 'react';
export default {
  Button,
  React
};